/* global axios */
import ApiClient from './ApiClient';

/**
 * Nested account-scoped Journey 360 read model:
 * GET /api/v1/accounts/:account_id/contacts/:contact_id/journey_events
 *
 * Always keyed by contact DB id — never email/phone fan-out in the UI.
 */
class ContactJourneyEventsAPI extends ApiClient {
  constructor() {
    super('journey_events', { accountScoped: true });
  }

  list(contactId, params = {}) {
    if (contactId == null || contactId === '') {
      return Promise.reject(new Error('contactId is required'));
    }

    return axios.get(`${this.baseUrl()}/contacts/${contactId}/journey_events`, {
      params,
    });
  }
}

export default new ContactJourneyEventsAPI();
